export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    return
  }
  const userStore = useUserStore()
  const { user } = storeToRefs(userStore)
  const toLogin = (('modal' in to.query) && to.query.modal === 'login') || to.name === 'login'
  if (toLogin && user.value !== null) {
    return navigateTo({ name: to.name ?? 'index', query: { ...to.query, modal: undefined } })
  }
})
